import axiosInstance from './axiosInstance';
import { PluginsResponse } from '../types/Plugin';

export const pluginService = {
  async getPlugins(): Promise<PluginsResponse> {
    try {
      const response = await axiosInstance.get('/studio/cms/plugins');
      return response.data;
    } catch (error: any) {
      console.error('Get plugins error:', error);
      throw new Error(
        error.response?.data?.message || 
        error.response?.data?.detail || 
        error.message || 
        'Failed to fetch plugins'
      );
    }
  },

  async getActivePlugins(): Promise<PluginsResponse> {
    try {
      const response = await this.getPlugins();
      const activePlugins = response.plugins.filter(p => p.status === 'active');
      return {
        ...response,
        plugins: activePlugins,
        total: activePlugins.length,
      };
    } catch (error) {
      console.error('Get active plugins error:', error);
      throw error;
    }
  },
};